/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectSettingsResource
 */
export interface ProjectSettingsResource {
    /**
     * Threshold over which a subsequent administration validation is required
     * @type {number}
     * @memberof ProjectSettingsResource
     */
    quoteValidationThreshold?: number;
    /**
     * An alternative email address for sending initial quote submission instead of defined client
     * @type {string}
     * @memberof ProjectSettingsResource
     */
    quoteValidationAlternativeInitialEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectSettingsResource
     */
    projectAutoValidationDelay: ProjectSettingsResourceProjectAutoValidationDelayEnum;
}


/**
 * @export
 */
export const ProjectSettingsResourceProjectAutoValidationDelayEnum = {
    Standard: 'STANDARD',
    Extended: 'EXTENDED'
} as const;
export type ProjectSettingsResourceProjectAutoValidationDelayEnum = typeof ProjectSettingsResourceProjectAutoValidationDelayEnum[keyof typeof ProjectSettingsResourceProjectAutoValidationDelayEnum];


/**
 * Check if a given object implements the ProjectSettingsResource interface.
 */
export function instanceOfProjectSettingsResource(value: object): value is ProjectSettingsResource {
    if (!('projectAutoValidationDelay' in value) || value['projectAutoValidationDelay'] === undefined) return false;
    return true;
}

export function ProjectSettingsResourceFromJSON(json: any): ProjectSettingsResource {
    return ProjectSettingsResourceFromJSONTyped(json, false);
}

export function ProjectSettingsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectSettingsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'quoteValidationThreshold': json['quoteValidationThreshold'] == null ? undefined : json['quoteValidationThreshold'],
        'quoteValidationAlternativeInitialEmail': json['quoteValidationAlternativeInitialEmail'] == null ? undefined : json['quoteValidationAlternativeInitialEmail'],
        'projectAutoValidationDelay': json['projectAutoValidationDelay'],
    };
}

export function ProjectSettingsResourceToJSON(value?: ProjectSettingsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'quoteValidationThreshold': value['quoteValidationThreshold'],
        'quoteValidationAlternativeInitialEmail': value['quoteValidationAlternativeInitialEmail'],
        'projectAutoValidationDelay': value['projectAutoValidationDelay'],
    };
}

